import { render, staticRenderFns } from "./jituanzongbu.vue?vue&type=template&id=761343e2&scoped=true"
import script from "./jituanzongbu.vue?vue&type=script&lang=js"
export * from "./jituanzongbu.vue?vue&type=script&lang=js"
import style0 from "./jituanzongbu.vue?vue&type=style&index=0&id=761343e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "761343e2",
  null
  
)

export default component.exports